module.exports = __webpack_public_path__ + "static/media/logo.add5a0c4.png";